import { render, staticRenderFns } from "./TableProList.vue?vue&type=template&id=fdf4fd4e&scoped=true"
import script from "./TableProList.vue?vue&type=script&lang=js"
export * from "./TableProList.vue?vue&type=script&lang=js"
import style0 from "./TableProList.vue?vue&type=style&index=0&id=fdf4fd4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf4fd4e",
  null
  
)

export default component.exports